import store, { StoreAPI } from 'store2';

export const TimeUnitsInMs = {
  OneWeek: 7 * 24 * 60 * 60 * 1000,
  OneDay: 24 * 60 * 60 * 1000,
  OneHour: 60 * 60 * 1000,
  OneMinute: 60 * 1000,
} as const;
export const DefaultCacheTTL = 5 * 60 * 1000;
export interface Cache {
  has: (key: string) => boolean;
  get: <T>(key: string, defaultValue?: T) => T | undefined | null;
  set: <T>(key: string, value: T, ttl?: number) => void;

  clearAll: () => void;
  // getNamespaced(namespace: string): Cache;
}

class StoreApiCache implements Cache {
  constructor(private storeApi: StoreAPI) {}
  has(key: string): boolean {
    return this.storeApi.has(key);
  }
  get<T>(key: string, defaultValue?: T): T | undefined | null {
    const now = new Date();
    const item = this.storeApi.get(key);
    // if the item doesn't exist, return null
    if (!item) {
      return defaultValue;
    }
    if (item.expiry && now.getTime() > item.expiry) {
      console.log(`${key} has expired. Removing it from cache.`);
      this.storeApi.remove(key);
      return defaultValue;
    }
    return this.storeApi.get(key)?.value;
  }
  set<T>(key: string, value: T, ttl?: number): void {
    // `item` is an object which contains the original value
    // as well as the time when it's supposed to expire
    const item = {
      value: value,
      expiry: ttl,
    };
    this.storeApi.set(key, item);
  }
  clearAll(): void {
    this.storeApi.clearAll();
  }

  //   getNamespaced(namespace: string): Cache {
  //     return this.storeApi.namespace(namespace);
  //   }
}

export const sessionCache: Cache = new StoreApiCache(store.session);
export const localCache: Cache = new StoreApiCache(store.local);
export const defaultCache = localCache;
